export default __webpack_public_path__ + "de344505ab3c9a7c9911eb642ba24b81.png";